import React from 'react'
import { Placeholder } from 'semantic-ui-react'

export default function BreadcrumbPlaceholder() {
	return <Placeholder style={{width: '10em'}}>
		<Placeholder.Line  />
	</Placeholder>
}